<template>
  <v-toolbar app dense height="44" extended extension-height="auto" color="#303030">

    <v-toolbar-side-icon small tabindex="11" data-l10n-id="toggle_sidebar"
                         @click.native="toggle">
      <v-icon data-recite-skip="true" v-if="!drawer">menu</v-icon>
      <v-icon data-recite-skip="true" v-else>chevron_left</v-icon>
    </v-toolbar-side-icon>

    <v-btn icon small id="viewFind" title="Find in Document" tabindex="12" data-l10n-id="findbar">
      <v-icon data-recite-skip="true">search</v-icon>
    </v-btn>

    <v-btn icon small id="documentProperties" class="hidden-xs-only" title="Document Properties…" tabindex="62" data-l10n-id="document_properties">
      <v-icon data-recite-skip="true">info_outline</v-icon>
    </v-btn>

    <v-spacer></v-spacer>

    <v-toolbar-items v-show="loaded" class="align-center pager">
      <v-btn icon small tabindex="13" data-l10n-id="previous" id="previous" :disabled="previousBtnDisabled">
        <v-icon data-recite-skip="true">keyboard_arrow_left</v-icon>
      </v-btn>

      <v-text-field class="d-inline-flex" type="text" v-model="pageNumber"
                    @change="viewPage" tabindex="14" data-l10n-id="page"
                    size="4" class="text-xs-right page-number" :min="min"
                    :max="max"></v-text-field>
      <v-flex id="numPages" class="toolbarLabel d-inline-flex"></v-flex>

      <v-btn icon small tabindex="15" data-l10n-id="next" id="next" :disabled="nextBtnDisabled">
        <v-icon data-recite-skip="true">keyboard_arrow_right</v-icon>
      </v-btn>
    </v-toolbar-items>

    <v-spacer></v-spacer>

    <v-toolbar-items class="align-center">

      <v-btn icon small id="pageRotateCw"
             title="Rotate Clockwise" tabindex="33" data-l10n-id="page_rotate_cw">
        <v-icon data-recite-skip="true">rotate_right</v-icon>
      </v-btn>

      <v-btn icon small id="download"
             title="Download" tabindex="34" data-l10n-id="download">
        <v-icon data-recite-skip="true">get_app</v-icon>
      </v-btn>

      <v-btn icon small id="print" class="hidden-xs-only"
             title="Print" tabindex="35" data-l10n-id="print">
        <v-icon data-recite-skip="true">print</v-icon>
      </v-btn>

    </v-toolbar-items>

    <div id="findbar" slot="extension" class="findbar hidden">

        <div id="findbarInputContainer">
          <input id="findInput" class="toolbarField" title="Find" placeholder="Find in document…" tabindex="91" data-l10n-id="find_input">
          <div class="splitToolbarButton">
            <button id="findPrevious" class="toolbarButton findPrevious" title="Find the previous occurrence of the phrase" tabindex="92" data-l10n-id="find_previous">
              <span data-l10n-id="find_previous_label">Previous</span>
            </button>
            <div class="splitToolbarButtonSeparator"></div>
            <button id="findNext" class="toolbarButton findNext" title="Find the next occurrence of the phrase" tabindex="93" data-l10n-id="find_next">
              <span data-l10n-id="find_next_label">Next</span>
            </button>
          </div>
        </div>

        <div id="findbarOptionsContainer">
          <!--<v-checkbox tabindex="94" v-model="findHighlightAll">-->
            <!--<label slot="label" data-l10n-id="find_highlight">Highlight all</label>-->
          <!--</v-checkbox>-->

          <!--<v-checkbox tabindex="94" v-model="findMatchCase">-->
            <!--<label slot="label" data-l10n-id="find_match_case_label">Match case</label>-->
          <!--</v-checkbox>-->
          <input type="checkbox" id="findHighlightAll" class="toolbarField" tabindex="94">
          <label for="findHighlightAll" class="toolbarLabel" data-l10n-id="find_highlight">Highlight all</label>
          <input type="checkbox" id="findMatchCase" class="toolbarField" tabindex="95">
          <label for="findMatchCase" class="toolbarLabel" data-l10n-id="find_match_case_label">Match case</label>

          <span id="findResultsCount" class="toolbarLabel hidden"></span>
        </div>

        <div id="findbarMessageContainer">
          <span id="findMsg" class="toolbarLabel"></span>
        </div>
    </div>


  </v-toolbar>
</template>

<script>

  export default {
    name: 'AppToolbar',
    model: {
      prop: 'value',
      event: 'input'
    },

    props: {
      value: Boolean
    },

    data () {
      return {
        pageNumber: null,
        min: 1,
        max: null,
        drawer: false,

        elPageNum: null,
        elToggleSB: null,

        findShow: false,

        findHighlightAll: false,
        findMatchCase: false,
        loaded: false,
      }
    },

    created () {
      window.addEventListener('documentload', () => {
        this.loaded = true
      })
    },

    mounted () {
      // some hacky way to get things initialized after viewer.js initialized
      let handler = setInterval(() => {
        if (!this.hasClass(document.getElementsByTagName('body')[0], 'loadingInProgress')) {
          this.$emit('initialized')
          this.initialize()
          clearInterval(handler)
        }
      }, 100)

      this.drawer = this.value

      this.$watch('value', (newVal) => {
        this.drawer = newVal
      })
    },

    methods: {
      initialize () {
        this.elPageNum = document.getElementById('pageNumber')
        this.elToggleSB = document.getElementById('sidebarToggle')
        this.max = this.elPageNum.getAttribute('max')
        this.syncPage()

        if (this.hasClass(document.getElementById('outerContainer'), 'sidebarOpen')) {
          this.elToggleSB.click()
        }

        this.__bindEvents()
      },

      __bindEvents () {
        // navigation
        window.addEventListener('pagechange', () => {
          this.syncPage()
        })
      },

      viewPage (value) {
        this.elPageNum.value = value
        this.trigger(this.elPageNum, 'change')
      },

      /**
       * Take page number from Viewer value
       */
      syncPage () {
        this.pageNumber = this.elPageNum.value
      },

      trigger (element, eventName, payload) {
        if ('createEvent' in document) {
          const evt = document.createEvent('HTMLEvents')
          evt.initEvent(eventName, false, true)
          element.dispatchEvent(evt, payload)
        }
        else {
          element.fireEvent('on' + eventName)
        }
      },

      hasClass (element, className) {
        return ((' ' + element.className + ' ').replace(/[\n\t]/g, ' ').indexOf(' ' + className + ' ') > -1)
      },

      toggle () {
        this.elToggleSB.click()
        this.drawer = !this.drawer //this.hasClass(document.getElementById('outerContainer'), 'sidebarOpen')
        this.$emit('input', this.drawer)
      }
    },

    computed: {
      previousBtnDisabled () {
        return parseInt(this.pageNumber) <= this.min
      },

      nextBtnDisabled () {
        return parseInt(this.pageNumber) >= this.max
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AppToolbar.vue